/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fun_Zippy_Chipmunk_LeapInputs */

const fr_fun_zippy_chipmunk_leap = /** @type {(inputs: Fun_Zippy_Chipmunk_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom`)
};

/**

* @param {Fun_Zippy_Chipmunk_LeapInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fun_zippy_chipmunk_leap = /** @type {((inputs?: Fun_Zippy_Chipmunk_LeapInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fun_Zippy_Chipmunk_LeapInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fun_zippy_chipmunk_leap(inputs)
});